module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/050-mauritania-27f5575d44ff50b36c98ac0ad32ce878.svg";